import React from "react";
import {EmailLink, TelephoneLink} from "BaseComponents/Link/";
import {ButtonText as BtnText, RectangularButton} from "Buttons";
import useBreakpoint from "Hooks/useBreakpoint";
import {useGlobal} from "reactn";
import {
    AddressLink,
    AddressTextWrapper,
    AddressWrapper,
    BottomWrapper,
    CardWrapper,
    ClosePopup,
    CrossIconItem,
    Icon,
    ImageWrapper,
    Info,
    InnerWrapper,
    Letter,
    OuterWrapper,
    P,
    TopWrapper,
} from "./ResultCard.styles";
import {GetColorFromUnitType} from "Helpers/ColorHelper";

export const ResultCard = ({marker, isPopup, DirectionsLinkText, directionLink, onPopupClose}) => {
    const {
        SortingName,
        Name,
        Address,
        Contact,
        EMailText,
        EMail,
        Phone,
        Url,
        Target,
        Image,
        Position,
        ZipCode,
        Municipality,
        ButtonText,
        Company,
        GlobalUnit,
        UnitType
    } = marker;
    const isMobile = useBreakpoint("mobile");
    const directionUrl =
        SortingName.length > 1
            ? Position != undefined
                ? `https://www.google.com/maps/dir/?api=1&destination=${Position.Latitude},${Position.Longitude}`
                : directionLink
            : "";
    const [theme] = useGlobal("theme");

    const color = GetColorFromUnitType(UnitType, theme, Company, GlobalUnit);
    
    return SortingName.length == 1 ? (
        <Letter>{SortingName}</Letter>
    ) : (
        <OuterWrapper isPopup={isPopup}>
            {onPopupClose && <ClosePopup tabIndex="0" onClick={onPopupClose} className={'close--Button'}>
                <CrossIconItem rotate={'-45deg'}/>
                <CrossIconItem rotate={'45deg'}/>
            </ClosePopup>}
            <CardWrapper isPopup={isPopup}>
                <TopWrapper>
                    <P margin={"0"} bold>
                        <Icon color={color} className="icon-home"></Icon>
                        {Name}
                    </P>
                </TopWrapper>
                <Info>
                    <InnerWrapper>
                        <AddressWrapper>
                            <Icon color={color} className="icon-marker-1"></Icon>
                            {!!Address?.length && !GlobalUnit && (
                                <AddressTextWrapper>
                                    <span>{`${Address}, ${ZipCode} ${Municipality}`}</span>
                                    {!!directionUrl?.length && (
                                        <AddressLink
                                            tabindex="0"
                                            color={theme.colors.primary}
                                            target="_blank"
                                            href={directionUrl}
                                            text={DirectionsLinkText}
                                        />
                                    )}
                                </AddressTextWrapper>
                            )}
                            {GlobalUnit && <AddressTextWrapper>
                                {Address?.length > 0 && <span>{`${Address}`}</span>}
                                {ZipCode?.length > 0 && <span>{`${ZipCode}`}</span>}
                                {Municipality?.length > 0 && <span>{`${Municipality}`}</span>}
                                {directionUrl?.length > 0 && (
                                    <AddressLink
                                        tabIndex="0"
                                        color={theme.colors.primary}
                                        target="_blank"
                                        href={directionUrl}
                                        text={DirectionsLinkText}
                                    />
                                )}
                            </AddressTextWrapper>
                            }
                        </AddressWrapper>
                        {!!Contact?.length && (
                            <P>
                                <Icon color={color} className="icon-user"></Icon>
                                {Contact}
                            </P>
                        )}
                        {!!EMail?.length && <EmailLink tabIndex="0" text={EMailText} email={EMail} margin={"5px 0 5px 0"}/>}
                        {!!Phone?.length && <TelephoneLink tabIndex="0" phone={Phone} margin={"5px 0 5px 0"}/>}
                    </InnerWrapper>
                    {Url?.length &&
                        <BottomWrapper height="40px" isPopup={isPopup}>
                            <RectangularButton
                                inverted
                                bgColor={theme.colors.bg1}
                                href={Url}
                                target={Target ?? "_self"}
                                width="100%"
                                margin="0"
                                smallmargin="0"
                                height="100%"
                                widthsmall="100%"
                                tabIndex="0"
                                role={"button"}
                            >
                                <BtnText
                                    lang="en"
                                    forcedFontSize="18px"
                                    forcedFontSizeSmall="18px"
                                    heading={Name}
                                >
                                    {ButtonText}
                                </BtnText>
                            </RectangularButton>
                        </BottomWrapper>
                    }
                </Info>
            </CardWrapper>
            {((!isMobile && isPopup) || !isPopup) && Image && (
                <ImageWrapper bgImage={Image} isPopup={isPopup}></ImageWrapper>
            )}
        </OuterWrapper>
    );
};
